import { categoryBlocksForSlot, feedColorStyle, FEED_COLOR_MAP } from "../lib/feedingConstants";

// Shared Profenda renderer for ONE meal slot's lines. Presentation modes share the SAME data logic:
//   card    = Alimentazione > Cavalli Card: vertical micro-card = edge-to-edge CATEGORY header +
//             centered body (product name up to 2 lines + larger semibold quantity). When product
//             name == category the header stays and the redundant name is hidden (Categoria -> Qty).
//   stacked = HorseDetail: compact tile (category small above, name · qty inline).
//   inline  = Elenco: denser horizontal pills.
// Fascia label lives OUTSIDE this component (iteration_81 hierarchy preserved). Color = feed_item.
export function SlotBlocks({ slotLines, itemsMap, catOrder, variant = "stacked" }) {
  const blocks = categoryBlocksForSlot(slotLines, itemsMap, catOrder);
  const entries = blocks.flatMap((b) => b.entries.map((e) => ({ ...e, category: b.category })));
  if (!entries.length) return null;

  if (variant === "inline") {
    return (
      <div className="flex flex-wrap gap-x-1.5 gap-y-1" data-testid="profenda-tiles-inline">
        {entries.map((e, i) => {
          const st = feedColorStyle(e.color);
          return (
            <span key={i} data-testid={`food-pill-${e.feed_item_id}`} style={st || undefined}
              className={`inline-flex items-baseline gap-1 rounded px-1.5 py-0.5 text-sm leading-tight ${st ? "border border-black/5" : ""}`}>
              {!e.collapsed && <span className="text-[10px] font-semibold text-[#8C6D4F]">{e.category}</span>}
              <span className="text-[#3C463F]">{e.name} <span className="text-[#9AA39C]">·</span> {e.qty}</span>
            </span>
          );
        })}
      </div>
    );
  }

  if (variant === "card") {
    return (
      <div className="flex flex-wrap items-stretch gap-1.5" data-testid="profenda-tiles">
        {entries.map((e, i) => {
          const c = FEED_COLOR_MAP[e.color];
          const headerBg = c ? c.border : "#EFE7D6";
          const bodyBg = c ? c.bg : "#FBF8F2";
          const borderCol = c ? c.border : "#E7DFCF";
          return (
            <div key={i} data-testid={`food-tile-${e.feed_item_id}`} style={{ borderColor: borderCol }}
              className="flex flex-col rounded-lg border overflow-hidden min-w-[6.5rem] max-w-[12rem]">
              <div style={{ backgroundColor: headerBg }} className="px-2 py-1 text-center text-[10px] font-semibold uppercase tracking-wide text-[#5F4A32] leading-none border-b" >
                {e.category}
              </div>
              <div style={{ backgroundColor: bodyBg }} className="flex-1 flex flex-col items-center justify-center text-center px-2.5 py-2 gap-0.5">
                {!e.collapsed && <span title={e.name} className="text-[12px] text-[#3C463F] leading-tight line-clamp-2 break-words">{e.name}</span>}
                <span className="text-[15px] font-semibold text-[#1B3B2B] leading-tight">{e.qty}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // stacked (HorseDetail) — unchanged compact tile
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="profenda-tiles">
      {entries.map((e, i) => {
        const st = feedColorStyle(e.color);
        return (
          <div key={i} data-testid={`food-tile-${e.feed_item_id}`} style={st || undefined}
            className={`rounded-lg px-2.5 py-1.5 border max-w-full ${st ? "border-black/5" : "border-[#EAE3D3] bg-[#FBF8F2]"}`}>
            {!e.collapsed && <p className="text-[10px] font-semibold text-[#8C6D4F] leading-none mb-0.5">{e.category}</p>}
            <p className="text-sm text-[#3C463F] leading-tight">{e.name} <span className="text-[#9AA39C]">·</span> {e.qty}</p>
          </div>
        );
      })}
    </div>
  );
}
